<template>
  <div id="main">
    <div class="main">
      <left-nav title="大学辅导" navCode="20"></left-nav>
      <mid-swiper :adCode=58 :navList="universityMainNav"></mid-swiper>
      <right-form :consultList="consult"></right-form>
      <div style="clear: both"></div>
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import LeftNav from '@/common-components/Channelleftnav'
import MidSwiper from '@/common-components/Channelmidswiper'
import RightForm from '@/common-components/Rightform'
import { consult } from 'js/univercity/consult.js'
import { universityMainNav } from 'js/univercity/mainnav'
export default {
  name: 'univercityHomePage',
  data () {
    return {
      universityMainNav,
      consult
    }
  },
  components: {
    LeftNav,
    MidSwiper,
    RightForm
  }
}
</script>

<style scoped lang="stylus">
@import '~styles/varibles.styl'
#main
  width: 100%
  margin-bottom: 20px
  .main
    width: $defaultwidth
    margin: 0 auto
    position: relative
    min-height: 360px
</style>



// WEBPACK FOOTER //
// src/pages/univercity/components/swiper/Swiper.vue